export const PATCH_WITHOUT_DETAIL = new Set(['shelves']);

export function joinUrl(...parts) {
  return parts
    .filter(p => p != null && p !== '')
    .map((p, i) => {
      let s = String(p);
      if (i === 0) return s.replace(/\/+$/, ''); // 첫 파트: 끝 슬래시 제거
      return s.replace(/^\/+/, '').replace(/\/+$/, ''); // 이후 파트: 앞/뒤 슬래시 제거
    })
    .join('/');
}

export function lastPathSegment(url) {
  const clean = String(url).replace(/\/+$/, '');
  const segs = clean.split('/').filter(Boolean);
  return segs[segs.length - 1] || '';
}
